import React from 'react';
import Link from 'next/link';
import { ChevronRight } from 'lucide-react';

export interface BreadcrumbItem {
  label: string;
  href?: string;
  isCurrentPage?: boolean;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  className?: string;
}

export function Breadcrumb({ items, className = '' }: BreadcrumbProps) {
  return (
    <nav className={`flex items-center space-x-1 text-sm text-neutral-600 ${className}`} aria-label="Breadcrumb">
      <Link 
        href="/" 
        className="hover:text-primary-600 transition-colors font-medium"
        aria-label="Home"
      >
        Home
      </Link>
      
      {items.map((item, index) => (
        <React.Fragment key={index}>
          <ChevronRight className="w-4 h-4 text-neutral-400" />
          {item.href && !item.isCurrentPage ? (
            <Link
              href={item.href}
              className="hover:text-primary-600 transition-colors font-medium"
            >
              {item.label}
            </Link>
          ) : (
            <span className={`${item.isCurrentPage ? 'text-neutral-900 font-semibold' : 'text-neutral-600'}`}>
              {item.label}
            </span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
}
